import { SET_COLLECTION_LIST, DELETE_FROM_COLLECTION_LIST,
  SET_COLLECTION_PLAYLIST, ADD_COLLECTION_PLAYLIST, REMOVE_COLLECTION_PLAYLIST,
  SET_COLLECTION_ARRANGEMENT_PLAYLIST,
  ADD_COLLECTION_ARRANGEMENT_TO_PLAYLIST,
  REMOVE_COLLECTION_ARRANGEMENT_FROM_PLAYLIST,
  SET_COLLECTION_AUTHORS, SET_COLLECTION_GENRES } from '../constants/collection';
import collectionAPI from '../../_api/collection';
import { reset, stopSubmit } from 'redux-form';
import notifier from '../../_utils/notifier';
import { decrementPlaylistsCount, incrementPlaylistsCount } from './auth';
import userAPI from '../../_api/user';

const setArrangements = (list) => ({type: SET_COLLECTION_LIST, list});
const removeFromArrangements = ids => ({ type: DELETE_FROM_COLLECTION_LIST, ids });
const setPlaylists = list => ({type: SET_COLLECTION_PLAYLIST, list});
const addPlaylist = (newPlaylist) => ({type: ADD_COLLECTION_PLAYLIST, newPlaylist});
const removePlaylist = (id) => ({type: REMOVE_COLLECTION_PLAYLIST, id});
const setArrangementPlaylists = (offer, list) =>
  ({type: SET_COLLECTION_ARRANGEMENT_PLAYLIST, offer, list});
const addArrangementToPlaylist = (offer, playlist) => ({type: ADD_COLLECTION_ARRANGEMENT_TO_PLAYLIST, offer, playlist});
const removeArrangementFromPlaylist = (offer, playlist) => ({ type: REMOVE_COLLECTION_ARRANGEMENT_FROM_PLAYLIST, offer, playlist });
const setAuthors = (list) => ({type: SET_COLLECTION_AUTHORS, list});
const setGenres = (list) => ({type: SET_COLLECTION_GENRES, list});

export const getCollectionArrangements = (author_slug=null, tag_slug=null) => async (dispatch) => {
  let response;
  response = await collectionAPI.getArrangements(author_slug, tag_slug);
  if (response) dispatch(setArrangements(response));
  return response;
};

export const deleteFromArrangements = (ids) => async (dispatch) => {
  const response = await collectionAPI.deleteFromArrangements(ids);
  if (response) dispatch(removeFromArrangements(ids));
};

export const getCollectionPlaylists = () => async (dispatch) => {
  let response;
  response = await collectionAPI.getPlaylists();
  if (response) dispatch(setPlaylists(response));
};

export const getCollectionArrangementPlaylists = (offer) => async (dispatch) => {
  let response;
  response = await collectionAPI.getArrangementPlaylists(offer);
  if (response) dispatch(setArrangementPlaylists(offer, response));
};

export const createPlaylist = (payload) => async (dispatch) => {
  const response = await collectionAPI.createPlaylist(payload);
  if (response) {
    dispatch(addPlaylist(response));
    dispatch(reset('playlistForm'));
    dispatch(incrementPlaylistsCount());
  }
};

export const getPlaylist = (id) => async (dispatch) => {
  const response = await collectionAPI.getPlaylist(id);
  if (response) {
    return response;
  }
};

export const getPlaylistArrangements = (id) => async (dispatch) => {
  let response;
  response = await collectionAPI.getPlaylistArrangements(id);
  if (response) dispatch(setArrangements(response));
};

export const deletePlaylist = (id) => async (dispatch) => {
  const response = await collectionAPI.deletePlaylist(id);
  dispatch(setArrangements([]));
  dispatch(removePlaylist(id));
  dispatch(decrementPlaylistsCount());
};

export const updatePlaylist = (id, payload) => async (dispatch) => {
  const response = await collectionAPI.updatePlaylist(id, payload);
  if (response) {
    notifier.success(gettext('Изменения внесены.'));
    return response;
  }
};

export const checkUncheckPlaylist = (payload) => async (dispatch) => {
  const response = await collectionAPI.checkUncheckPlaylist(payload);
  if (response){
    if (response === 'ok') {
      dispatch(removeArrangementFromPlaylist(payload.offer, payload.playlist));
      notifier.info(gettext('Аранжировка успешно удалена из плейлиста.'));
    } else {
      dispatch(addArrangementToPlaylist(response.offer, response.playlist));
      notifier.success(gettext('Аранжировка успешно добавлена в плейлист.'));
    }
  }
};

export const getCollectionAuthors = () => async (dispatch) => {
  let response;
  response = await collectionAPI.getAuthors();
  if (response) dispatch(setAuthors(response));
};

export const getAuthor = (slug) => async (dispatch) => {
  const response = await userAPI.getUserData(slug);
  if (response) {
    return response;
  }
};

export const getCollectionGenres = () => async (dispatch) => {
  let response;
  response = await collectionAPI.getGenres();
  if (response) dispatch(setGenres(response));
};

export const getGenre = (slug) => async (dispatch) => {
  const response = await collectionAPI.getGenre(slug);
  if (response) {
    return response;
  }
};

export const getGenreArrangements = (slug) => async (dispatch) => {
  let response;
  response = await collectionAPI.getGenreArrangements(slug);
  if (response) dispatch(setArrangements(response));
};

